<div class="ui-g m-0 portal-header">
  <div class="ui-g-12">
    <h1 class="show-on-desktop">
      {{ 'DATA_PORTAL.TITLE' | translate }}
    </h1>
  </div>
</div>

<div class="portal-content">

  <div class="ui-g" *ngIf="showSearch">
    <div class="ui-g-offset-8 ui-g-4">
      <p-autoComplete
        [placeholder]="'DATA_PORTAL.SEARCH.PLACEHOLDER' | translate"
        [suggestions]="entityList | async"
        field="name"
        [forceSelection]="true"
        (completeMethod)="search($event)"
        (onSelect)="fetchEntity($event)">
      </p-autoComplete>
    </div>
  </div>

  <div *ngIf="entity">
    <div class="ui-g">
      <div class="ui-g-12 text-left">
        <h2>
          {{ entity.name }}
          <span *ngIf="entityLevel === searchEntityLevels.ORGANIZATION"
                class="fright pointer"
                (click)="changeFollowStatus()"
                [ngSwitch]="entity.followedByUser">
            <span *ngSwitchCase="true"
                  [pTooltip]="'DATA_PORTAL.FOLLOW_TOOLTIP' | translate">
              <i class="fas fa-star primary-color"></i>
            </span>
            <span *ngSwitchDefault
                  [pTooltip]="'DATA_PORTAL.UNFOLLOW_TOOLTIP' | translate">
              <i class="fa fa-star primary-color"></i>
            </span>
          </span>
        </h2>
      </div>
    </div>

    <div class="p-grid justify-center dashboard-container">
      <div *ngIf="!showCensus" class="p-col contacts">
        <wsd-extended-card *ngIf="entity">
          <wsd-side-panel
            *gsShowIfHasPermission="['NDP_ORGANIZATION_CONTACT_DATA_READ', 'NDP_FEDERATIONS_READ',
             'NDP_REGION_READ', 'NDP_WORLD_READ']"
            [entity]="entity"
            (onContactUpdate)="updateOrganizationContacts()"
            [entityLevel]="entityLevel">
          </wsd-side-panel>
        </wsd-extended-card>
        <div *gsShowIfHasPermission="['NDP_EXPORT_READ']" class="m-t-20">
          <wsd-extended-card
            [title]="'DATA_PORTAL.EXPORT.TITLE' | translate">
            <wsd-ndp-export
              [entityId]="entity.id"
              [entityLevel]="entityLevel">
            </wsd-ndp-export>
          </wsd-extended-card>
        </div>
      </div>

      <div *ngIf="showDocuments" class="p-col">
        <div [ngSwitch]="entityLevel">
          <div *ngSwitchCase="searchEntityLevels.ORGANIZATION">
            <wsd-extended-card
              [title]="'DATA_PORTAL.POLICY_DOCUMENTS.TITLE' | translate"
              [expanded]="showDocuments"
              [redirectTo]="['/organizations', entity.id, 'modify', 'constitution']"
              (sizeChanged)="showDocuments = !showDocuments">
              <wsd-policy-document-detail-organization
                *gsShowIfHasPermission="['NDP_ORGANIZATION_POLICY_DOCUMENTS_READ']"
                [entityId]="entity.id"
              ></wsd-policy-document-detail-organization>
            </wsd-extended-card>
          </div>
          <div *ngSwitchCase="searchEntityLevels.REGION">
            <wsd-extended-card
              [title]="'DATA_PORTAL.POLICY_DOCUMENTS.TITLE' | translate"
              [expanded]="showDocuments"
              (sizeChanged)="showDocuments = !showDocuments">
              <wsd-policy-document-detail-region-world
                *gsShowIfHasPermission="['NDP_REGION_READ']"
                [entityId]="entity.id"
                [entityLevel]="entityLevel">
              </wsd-policy-document-detail-region-world>
            </wsd-extended-card>
          </div>
          <div *ngSwitchCase="searchEntityLevels.WORLD">
            <wsd-extended-card
              [title]="'DATA_PORTAL.POLICY_DOCUMENTS.TITLE' | translate"
              [expanded]="showDocuments"
              (sizeChanged)="showDocuments = !showDocuments">
              <wsd-policy-document-detail-region-world
                *gsShowIfHasPermission="['NDP_WORLD_READ']"
                [entityId]="entity.id"
                [entityLevel]="entityLevel">
              </wsd-policy-document-detail-region-world>
            </wsd-extended-card>
          </div>
        </div>

      </div>
      <div *ngIf="showInteraction" class="p-col">
        <wsd-extended-card
          *ngIf="showInteraction"
          [title]="'DATA_PORTAL.INTERACTIONS.TITLE' | translate"
          [expanded]="showInteraction"
          [redirectTo]="['/organizations', entity.id, 'modify', 'interactions']"
          (sizeChanged)="showInteraction = !showInteraction">
          <wsd-interaction-detail
            *gsShowIfHasPermission="['NDP_ORGANIZATION_INTERACTION_READ', 'NDP_FEDERATIONS_READ']"
            [organizationId]="entity.id"
          ></wsd-interaction-detail>
        </wsd-extended-card>
      </div>
      <div *ngIf="showCensus" class="p-col-12">
        <wsd-extended-card
          *ngIf="showCensus"
          [title]="'DATA_PORTAL.CENSUS.TITLE' | translate"
          [expanded]="showCensus"
          (sizeChanged)="showCensus = !showCensus">
          <wsd-census-detail
            [entityLevel]="entityLevel"
            [entityId]="entity.id"
            [isFederation]="entity.children?.length > 0"
            [isNSO]="!entity.hasParent"
          ></wsd-census-detail>
        </wsd-extended-card>
      </div>
      <div class="p-col-9" *ngIf="!detailVisible">

        <div class="test-grid p-justify-start">
          <div>
            <div *ngIf="entityLevel===searchEntityLevels.ORGANIZATION">
              <div class="federations-widget" *ngIf="entity.children?.length">
                <wsd-federations
                  [federations]="entity.children"
                ></wsd-federations>
              </div>
            </div>


            <div class="p-col census widget-2">
              <wsd-census-widget
                [organizationId]="entity.id"
                [entityLevel]="entityLevel"
                [expanded]="showCensus"
                [isFederation]="entity.children?.length > 0"
                (sizeChanged)="showCensus = !showCensus; scrollTop()">
              </wsd-census-widget>
            </div>

            <div [ngSwitch]="entityLevel">
              <div *ngSwitchCase="searchEntityLevels.ORGANIZATION" class="p-col widget-1">
                <wsd-good-standing-organization
                  *gsShowIfHasPermission="['NDP_ORGANIZATION_GOOD_STANDING_STATUS_READ', 'NDP_FEDERATIONS_READ']"
                  [organizationId]="entity.id">
                </wsd-good-standing-organization>
              </div>
              <div *ngSwitchCase="searchEntityLevels.REGION" class="p-col widget-1">
                <wsd-good-standing-region-world
                  *gsShowIfHasPermission="['NDP_REGION_READ']"
                  [entityId]="entity.id"
                  [entityLevel]="entityLevel">
                </wsd-good-standing-region-world>
              </div>
              <div *ngSwitchCase="searchEntityLevels.WORLD" class="p-col widget-1">
                <wsd-good-standing-region-world
                  *gsShowIfHasPermission="['NDP_WORLD_READ']"
                  [entityId]="entity.id"
                  [entityLevel]="entityLevel">
                </wsd-good-standing-region-world>
              </div>
            </div>

            <div *gsShowIfHasPermission="['NDP_ORGANIZATION_COMPLIANCY_READ']" class="p-col widget-1">
              <wsd-compliency
                [entityId]="entity.id"
                [entityLevel]="entityLevel"
              ></wsd-compliency>
            </div>

            <div [ngSwitch]="entityLevel">
              <div *ngSwitchCase="searchEntityLevels.ORGANIZATION" class="p-col widget-1">
                <wsd-annual-reports-organization
                  *gsShowIfHasPermission="['NDP_ORGANIZATION_ANNUAL_REPORT_READ', 'NDP_ORGANIZATION_FINANCIAL_REPORT_READ']"
                  [organizationId]="entity.id"
                  [groupAdminView]=showGroupAdminView
                ></wsd-annual-reports-organization>
              </div>
              <div *ngSwitchCase="searchEntityLevels.REGION" class="p-col widget-1">
                <wsd-annual-reports-region-world
                  *gsShowIfHasPermission="['NDP_REGION_READ']"
                  [entityId]="entity.id"
                  [entityLevel]="entityLevel">
                </wsd-annual-reports-region-world>
              </div>
              <div *ngSwitchCase="searchEntityLevels.WORLD" class="p-col widget-1">
                <wsd-annual-reports-region-world
                  *gsShowIfHasPermission="['NDP_WORLD_READ']"
                  [entityId]="entity.id"
                  [entityLevel]="entityLevel">
                </wsd-annual-reports-region-world>
              </div>
            </div>

            <div [ngSwitch]="entityLevel">
              <div *ngSwitchCase="searchEntityLevels.ORGANIZATION">
                <div *gsShowIfHasPermission="['NDP_ORGANIZATION_CONSTITUTION_READ', 'NDP_FEDERATIONS_READ']"
                     class="p-col widget-1">
                  <wsd-constitution-organization
                    [organizationId]="entity.id"
                  ></wsd-constitution-organization>
                </div>
              </div>
              <div *ngSwitchCase="searchEntityLevels.REGION">
                <div *gsShowIfHasPermission="['NDP_REGION_READ']" class="p-col widget-1">
                  <wsd-constitution-region-world
                    [entityId]="entity.id"
                    [entityLevel]="entityLevel">
                  </wsd-constitution-region-world>
                </div>
              </div>
              <div *ngSwitchCase="searchEntityLevels.WORLD">
                <div *gsShowIfHasPermission="['NDP_WORLD_READ']" class="p-col widget-1">
                  <wsd-constitution-region-world
                    [entityId]="entity.id"
                    [entityLevel]="entityLevel">
                  </wsd-constitution-region-world>
                </div>
              </div>
            </div>

            <div [ngSwitch]=entityLevel>
              <div *ngSwitchCase="searchEntityLevels.ORGANIZATION">
                <div class="p-col widget-1">
                  <wsd-policy-documents-organization
                    *gsShowIfHasPermission="['NDP_ORGANIZATION_POLICY_DOCUMENTS_READ']"
                    [expanded]="showDocuments"
                    [organizationId]="entity.id"
                    (sizeChanged)="showDocuments = !showDocuments; scrollTop()"
                  ></wsd-policy-documents-organization>
                  <wsd-policy-documents-organization
                    *ngIf="showGroupAdminView && !hasPolicyDocumentsPermission"
                    [expanded]="showDocuments"
                    [organizationId]="entity.id"
                    (sizeChanged)="showDocuments = !showDocuments; scrollTop()"
                  ></wsd-policy-documents-organization>
                </div>
                <div class="p-col widget-1"
                     *gsShowIfHasPermission="['NDP_ORGANIZATION_SUMMARY_NOTES_READ', 'NDP_FEDERATIONS_READ']">
                  <wsd-summary-note
                    [organizationId]="entity.id"
                  ></wsd-summary-note>
                </div>
              </div>
              <div *ngSwitchCase="searchEntityLevels.REGION">
                <div class="p-col widget-2">
                  <wsd-policy-documents-region-world
                    *gsShowIfHasPermission="['NDP_REGION_READ']"
                    [entityId]="entity.id"
                    [entityLevel]="entityLevel"
                    [expanded]="showDocuments"
                    (sizeChanged)="showDocuments = !showDocuments; scrollTop()">
                  </wsd-policy-documents-region-world>
                </div>
              </div>
              <div *ngSwitchCase="searchEntityLevels.WORLD">
                <div class="p-col widget-2">
                  <wsd-policy-documents-region-world
                    *gsShowIfHasPermission="['NDP_WORLD_READ']"
                    [entityId]="entity.id"
                    [entityLevel]="entityLevel"
                    [expanded]="showDocuments"
                    (sizeChanged)="showDocuments = !showDocuments; scrollTop()">
                  </wsd-policy-documents-region-world>
                </div>
              </div>
            </div>
            <div class="p-col widget-2"
                 *gsShowIfHasPermission="['NDP_ORGANIZATION_GSAT_READ', 'NDP_REGION_READ', 'NDP_FEDERATIONS_READ']">
              <wsd-global-support
                [entityId]="entity.id"
                [entityLevel]="entityLevel"
              ></wsd-global-support>
            </div>

            <div *ngIf="entityLevel===searchEntityLevels.ORGANIZATION">
              <div *gsShowIfHasPermission="['NDP_ORGANIZATION_INTERACTION_READ']">
                <div class="p-col widget-2">
                  <wsd-interactions
                    [expanded]="showInteraction"
                    [organizationId]="entity.id"
                    (sizeChanged)="showInteraction = !showInteraction; scrollTop()">
                  </wsd-interactions>
                </div>
              </div>
            </div>
            <div class="p-col widget-2"
                 *gsShowIfHasPermission="['NDP_ORGANIZATION_PROJECTS_WIDGET_READ', 'NDP_FEDERATIONS_READ']">
              <wsd-projects-count
                [entityLevel]="entityLevel"
                [organizationId]="entity.id"
                [organizationName]="entity.name">
              </wsd-projects-count>
            </div>

            <div [ngSwitch]="entityLevel">
              <div *ngSwitchCase="searchEntityLevels.ORGANIZATION" class="p-col widget-2">
                <wsd-safe-from-harm-organization
                  [organizationId]="entity.id"
                  [groupAdminView]=showGroupAdminView
                ></wsd-safe-from-harm-organization>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-12" style="display: inline-block" [ngSwitch]="entityLevel">
          <wsd-custom-widgets  [organizationId]="entity.id">
          </wsd-custom-widgets>
        </div>
      </div>

    </div>

  </div>
</div>


